export default {
    namespaced: true,
    state: {
        message: null,
        stack: null,
    },
    mutations: {
        clearError(state) {
            state.message = null;
            state.stack = null;
        },
        updateMessage(state, data) {
            state.message = data;
        },
        updateStack(state, data) {
            state.stack = data;
        },
    },
    getters: {
        errorMessage: state => {
            return state.message;
        },
        errorStack: state => {
            return state.stack;
        },
    },
};
